import type { Maybe } from '@adornis/base/utilTypes.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { Product } from '@chancenwerk/_cms/products/entities/Product.js';
import { DateTime } from 'luxon';
import { ZipCity } from '../adresse.js';

@Entity()
export class FundingCreationInformation extends AdornisEntity {
  public static override _class = 'FundingCreationInformation';

  @Field(type => [String])
  public kpfIDs: Maybe<string[]>;

  @Field(type => ZipCity)
  public city: Maybe<ZipCity>;

  @Field(type => DateTime)
  public fundingBegin: Maybe<DateTime>;

  @Field(type => DateTime)
  public fundingEnd: Maybe<DateTime>;

  @Field(type => Product)
  public productToFund: Maybe<Product>;

  @Field(type => String)
  public partnerFundingID: Maybe<string>;

  /**
   * 0 insert should, 1 insert is, 2 insert both
   */
  @Field(type => Int, {
    default: v => v ?? 2,
  })
  public creationType: Maybe<number>;
}
